<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
                <v-row>
                  <v-text-field v-model="editedItem.ACCNT" :label="$t('deviceadmin_col1')"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field v-model="editedItem.DESC" :label="$t('deviceadmin_col6')"></v-text-field>
                </v-row>
                <v-row>
                  <v-select v-model="editedItem.BGTYPE" :items="BGLIST" :label="$t('deviceadmin_col7')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                </v-row>

                <v-row dense>
                  <label>{{$t('deviceadmin_col11')}}</label>
                </v-row>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12" class="pa-0 ma-0">
                    <comdialog :comname="editedItem.COM_NAME" @callback="comdialogcb2" @cancelcallback="comsearchclear2"></comdialog>
                  </v-col>
                </v-row>

                <v-row dense>
                  <label>{{$t('deviceadmin_col12')}}</label>
                </v-row>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12"  class="pa-0 ma-0">
                    <bggroupdialog :bgname="editedItem.BGGROUP_NAME" :bgtype="editedItem.BGTYPE" :comidx="editedItem.COMIDX" @callback="bgdialogcb"></bggroupdialog>
                  </v-col>
                </v-row>

                <v-row dense>
                  <label>{{$t('deviceadmin_col13')}}</label>
                </v-row>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12"  class="pa-0 ma-0">
                    <bggroupdialog :bgname="editedItem.BGPRINT_NAME" :bgtype="2" :comidx="editedItem.COMIDX" @callback="bgprintdialogcb"></bggroupdialog>
                  </v-col>
                </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row dense align="center">

      <v-col cols="12" md="2" sm="12" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      
      <v-col offset-md="3" cols="12" md="3" sm="12" xs="12">
        <comdialog  :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0" align="center">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%;text-transform: none;" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>

  </v-row>

  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        dense
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.ACCNT>
          <a :class="sort_name=='ACCNT'?'cheader_sortselect':'cheader_sort'" @click="customsort('ACCNT')">{{$t('deviceadmin_col1')}}</a>
        </template>

        <template v-slot:header.SETTING>
          <a class="cheader_normal">{{$t('deviceadmin_col15')}}</a>
        </template>

        <template v-slot:header.POWER_NAME>
          <a :class="sort_name=='POWER_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('POWER_NAME')">{{$t('deviceadmin_col2')}}</a>
        </template>
        <template v-slot:header.PRINT_MSG>
          <a :class="sort_name=='PRINT_MSG'?'cheader_sortselect':'cheader_sort'" @click="customsort('PRINT_MSG')">{{$t('deviceadmin_col3')}}</a>
        </template>
        <template v-slot:header.PRINT_STATE>
          <a :class="sort_name=='PRINT_STATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('PRINT_STATE')">{{$t('deviceadmin_col4')}}</a>
        </template>
        <template v-slot:header.INK1DM>
          <a :class="sort_name=='INK1DM'?'cheader_sortselect':'cheader_sort'" @click="customsort('INK1DM')">B</a>
        </template>
        <template v-slot:header.INK2DM>
          <a :class="sort_name=='INK2DM'?'cheader_sortselect':'cheader_sort'" @click="customsort('INK2DM')">C</a>
        </template>
        <template v-slot:header.INK3DM>
          <a :class="sort_name=='INK3DM'?'cheader_sortselect':'cheader_sort'" @click="customsort('INK3DM')">M</a>
        </template>
        <template v-slot:header.INK4DM>
          <a :class="sort_name=='INK4DM'?'cheader_sortselect':'cheader_sort'" @click="customsort('INK4DM')">Y</a>
        </template>
        <template v-slot:header.PAPER_NAME>
          <a :class="sort_name=='PAPER_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('PAPER_NAME')">{{$t('deviceadmin_col5')}}</a>
        </template>
        <template v-slot:header.DESC>
          <a :class="sort_name=='DESC'?'cheader_sortselect':'cheader_sort'" @click="customsort('DESC')">{{$t('deviceadmin_col6')}}</a>
        </template>
        <template v-slot:header.BG_NAME>
          <a :class="sort_name=='BG_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('BG_NAME')">{{$t('deviceadmin_col7')}}</a>
        </template>
        <template v-slot:header.BGGROUP_NAME>
          <a :class="sort_name=='BGGROUP_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('BGGROUP_NAME')">{{$t('deviceadmin_col8')}}</a>
        </template>
        <template v-slot:header.BGPRINT_NAME>
          <a :class="sort_name=='BGPRINT_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('BGPRINT_NAME')">{{$t('deviceadmin_col14')}}</a>
        </template>
        <template v-slot:header.COM_NAME>
          <a :class="sort_name=='COM_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('COM_NAME')">{{$t('deviceadmin_col9')}}</a>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("deviceadmin_col10")}}</label>
        </template>        

        <template v-slot:item.ACCNT="{ item }">  
          <a @click="edit_item(item)">{{item.ACCNT}}</a>
        </template>     

        <template v-slot:item.SETTING="{ item }">  
            <v-icon small @click="setting_item(item)">mdi-cog</v-icon>
        </template>     

        <template v-slot:item.POWER_NAME="{ item }">  
          <template v-if="item.POWER_NAME == 'ON'">
            <label style="color:green;text-align:center">{{item.POWER_NAME}}</label>
          </template>
          <template v-else>
            <label style="color:red;text-align:center">{{item.POWER_NAME}}</label>
          </template>
        </template>     
        <template v-slot:item.INK1DM="{ item }">  
          <template v-if="item.INK1DM > 20">
            <label style="color:green;text-align:center">{{item.INK1DM}}</label>
          </template>
          <template v-else>
            <label style="color:red;text-align:center">{{item.INK1DM}}</label>
          </template>
        </template>     
        <template v-slot:item.INK2DM="{ item }">  
          <template v-if="item.INK2DM > 20">
            <label style="color:green;text-align:center">{{item.INK2DM}}</label>
          </template>
          <template v-else>
            <label style="color:red;text-align:center">{{item.INK2DM}}</label>
          </template>
        </template>     
        <template v-slot:item.INK3DM="{ item }">  
          <template v-if="item.INK3DM > 20">
            <label style="color:green;text-align:center">{{item.INK3DM}}</label>
          </template>
          <template v-else>
            <label style="color:red;text-align:center">{{item.INK3DM}}</label>
          </template>
        </template>     
        <template v-slot:item.INK4DM="{ item }">  
          <template v-if="item.INK4DM > 20">
            <label style="color:green;text-align:center">{{item.INK4DM}}</label>
          </template>
          <template v-else>
            <label style="color:red;text-align:center">{{item.INK4DM}}</label>
          </template>
        </template>     
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>
export default {
    data: () => ({

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
        COM_IDX: 0,
        BGTYPE:0,
        COM_NAME:'',
        DESC:'',
        BGGROUP_IDX:-1,
        BGPRINT_IDX:-1,
      },
      editedItem: {},
      

      //테이블 정의
      headers: [
        {text: '장비명', value: 'ACCNT', sortable: false, align:'left', width:150},
        {text: '설정', value: 'SETTING', sortable: false, align:'center', width:80},
        {text: '전원', value: 'POWER_NAME', sortable: false, align:'center', width:100},
        {text: '프린터 메시지', value: 'PRINT_MSG', sortable: false, align:'center' , width:200},
        {text: '프린터 상태', value: 'PRINT_STATE', sortable: false, align:'center' , width:150},
        {text: 'B', value: 'INK1DM', sortable: false, align:'center' , width:100},
        {text: 'C', value: 'INK2DM', sortable: false, align:'center' , width:100},
        {text: 'M', value: 'INK3DM', sortable: false, align:'center' , width:100},
        {text: 'Y', value: 'INK4DM', sortable: false, align:'center' , width:100},
        {text: '용지', value: 'PAPER_NAME', sortable: false, align:'center' , width:100},
        {text: '상세위치', value: 'DESC', sortable: false, align:'center' , width:150},
        {text: '배경타입', value: 'BG_NAME', sortable: false, align:'center' , width:100},
        {text: '배경그룹', value: 'BGGROUP_NAME', sortable: false, align:'center' , width:150},
        {text: '프린터그룹', value: 'BGPRINT_NAME', sortable: false, align:'center' , width:150},
        {text: '로그인기업', value: 'COM_NAME', sortable: false, align:'center' , width:150},
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center', width:100}
      ],
      itemList: [],

      //검색 파라메터
      sort_name: 'POWER_NAME',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
         
      //추가 변수들
      BGLIST: [
          {name:'가로', name2:"Horizontal",  value:0}
        , {name:'세로', name2:"Vertical",  value:1}
      ],

      SEARCH_COM_IDX: '',
      SEARCH_COM_NAME: '',

    }),

    mounted(){

      if(this.$session.get("GRADE") < 50){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){
      
    },

    methods: {
      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){
          
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          if(this.grade < 99){
            if(this.SEARCH_COM_IDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
          }

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/KioskList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , COM_IDX: this.SEARCH_COM_IDX
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.itemList.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/KioskUpdate',{
                IDX:this.editedItem.IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , COM_IDX:this.editedItem.COMIDX
              , ACCNT: escape(this.editedItem.ACCNT)
              , DESC: escape(this.editedItem.DESC)
              , BGGROUP_IDX: this.editedItem.BGGROUP_IDX == undefined ? -1 : this.editedItem.BGGROUP_IDX
              , BGPRINT_IDX: this.editedItem.BGPRINT_IDX == undefined ? -1 : this.editedItem.BGPRINT_IDX
              , BGTYPE: this.editedItem.BGTYPE
              , UP_ACCNT: this.$session.get("ACNT_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동

              }else{
                  this.$alert(this.$t("common_edit_fail"));
              }

          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{

          if(this.editedItem.ACCNT == undefined || this.editedItem.ACCNT.length < 1){
            this.$alert(this.$t('deviceadmin_msg1'));
            return;
          } 

          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/KioskInsert',{
                ADMIN_IDX:this.$session.get("ADMIN_IDX")
              , COM_IDX:this.editedItem.COMIDX 
              , ACCNT: escape(this.editedItem.ACCNT)
              , DESC: escape(this.editedItem.DESC)
              , BGTYPE: this.editedItem.BGTYPE
              , UP_ACCNT: this.$session.get("ACNT_IDX")
              , BGGROUP_IDX: this.editedItem.BGGROUP_IDX
              , BGPRINT_IDX: this.editedItem.BGPRINT_IDX == undefined ? -1 : this.editedItem.BGPRINT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },

      //신규 추가
      newinsert(){
        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)

        this.editedItem.COM_IDX = this.SEARCH_COM_IDX;
        this.editedItem.COMIDX = this.SEARCH_COM_IDX;
        this.editedItem.COM_NAME = this.SEARCH_COM_NAME;
        

        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      //설정
      setting_item(item){
        this.$router.push({path:"DeviceAdminSetting", query:{device:item.IDX, com:this.SEARCH_COM_IDX}});
      },


      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/KioskDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
                
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COMIDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //업체선택 콜백
      comdialogcb2(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COMIDX   = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear2(var2){
          this.editedItem.COM_NAME = "";
          this.editedItem.COMIDX  = 0;
      },

      //배경그룹 선택 콜백
      bgdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.BGGROUP_IDX  = val.IDX;
          this.editedItem.BGGROUP_NAME = val.NAME;
        }else{
          this.$alert(this.$t('deviceadmin_msg2'));
          return;
        }
      },

      bgprintdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.BGPRINT_IDX = val.IDX;
          this.editedItem.BGPRINT_NAME = val.NAME;
        }else{
          this.$alert(this.$t('deviceadmin_msg2'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.loadpage(1);
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
        this.SEARCH_COM_IDX  = null;
        this.SEARCH_COM_NAME = '';
        this.$session.set("COM_IDX",  null);
        this.$session.set("COM_NAME", "");
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.loadpage(1);
      },




    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>